import { useLocation, useNavigate } from 'react-router-dom'
import './WebBackButton.css'

const HIDDEN_PATHS = new Set(['/', '/profile', '/courses', '/favorites', '/auth'])
// Для лендинга свадебного курса — всегда возврат на главную, а не в историю
// (часто попадают по прямой ссылке или после auth, history.back уведёт в auth).
const HOME_BACK_PATHS = new Set(['/wc'])

export const WebBackButton = () => {
  const location = useLocation()
  const navigate = useNavigate()

  if (HIDDEN_PATHS.has(location.pathname)) return null

  const handleClick = () => {
    if (HOME_BACK_PATHS.has(location.pathname)) {
      navigate('/', { replace: true })
      return
    }
    if (window.history.length > 1) {
      navigate(-1)
    } else {
      navigate('/', { replace: true })
    }
  }

  return (
    <button
      type="button"
      className="web-back-button"
      aria-label="Назад"
      onClick={handleClick}
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path
          d="M12.5 4L6.5 10L12.5 16"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
